import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box, TextField} from "@mui/material";
import {Add, Edit} from "@mui/icons-material";
import {useTheme} from "@mui/material/styles";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {ITask, ITaskCHILD} from "../../../../../../utils/interfaces/my_projects/ITask";
import {IProject, IProjectCHILD} from "../../../../../../utils/interfaces/my_projects/IProject";
import useApiGetProjectTasks from "./api-hooks/useApiGetProjectTasks";
import useApiGetTask from "./api-hooks/useApiGetTask";
import Loading from "../../../../../ui/Loading";
import MuiAutocomplete from "../../../../../ui/mui/mui-input/MuiAutoComplete";
import MRTMuiButton from "../../../../../ui/mui/mui_react_table/MRTMuiButton";
import MuiModal from "../../../../../ui/mui/mui_modal/MuiModal";
import TaskForm from "./TaskForm";
import TasksTable from "./TasksTable";


interface Props {
    obj: ITask | ITaskCHILD | undefined,
    onChange: (obj: ITask | ITaskCHILD | undefined) => void,
    className: string,
    label?: string,
    required?: boolean
    withDefaultValueIfEmpty?: boolean
    project: IProject | IProjectCHILD | undefined
}

const TaskSelect = ({
                        obj: initialObj,
                        label,
                        onChange,
                        required,
                        withDefaultValueIfEmpty = false,
                        project,
                        ...props
                    }: Props) => {


    const theme = useTheme();
    const {t} = useTranslation()

    const [isEditFormOpen, setIsEditFormOpen] = useState<boolean>(false)
    const [isListTableOpen, setIsListTableOpen] = useState<boolean>(false)
    const [isCurrentInUserWasteCodeCardIsOpen, setIsCurrentInUserWasteCodeCardIsOpen] = useState(false)

    const [objs, setObjs] = useState<ITask[]>([]);
    const [obj, setObj] = useState<ITask | ITaskCHILD | undefined>(initialObj)

    useEffect(() => {
        setObj(undefined);
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data,
        isLoading,
    } = useApiGetProjectTasks(project?.id);


    useEffect(() => {
        if (data) {
            setObjs(data)
            if (!initialObj && data.length > 0 && withDefaultValueIfEmpty) {
                setObj(data[0]);
                onChange(data[0]);
            }
        }
    }, [data]);


    const {
        data: detailedObj,
    } = useApiGetTask(obj?.id);


    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        }
    }, [detailedObj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: ITask | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }
    };

    const handleChange = (obj: ITask | undefined) => {
        setObj(obj);
        onChange(obj)
    }

    useEffect(() => {
        onChange(obj);

    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            id="site-select"
                            options={objs}
                            getOptionLabel={(option) => option.name}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.name === value?.name}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={label ? t(label) : '' || t('recipient')}
                                    required={required}
                                />
                            )}
                            borderColor={theme.palette.primary.light}
                            onFocusBorderColor={theme.palette.primary.dark}
                            minWidth={300}
                        >


                            <MRTMuiButton
                                icon={<FormatListBulletedIcon sx={{color: theme.palette.primary.main}}/>}
                                onClick={() => setIsListTableOpen(true)}
                                small={true}
                                label={'show_list'}
                            />
                            <MRTMuiButton
                                icon={obj ? <Edit sx={{color: theme.palette.primary.main}}/> :
                                    <Add sx={{color: theme.palette.primary.main}}/>}
                                onClick={() => setIsEditFormOpen(true)}
                                small={true}
                                label={obj ? 'edit' : 'add'}
                            />
                        </MuiAutocomplete>
                    </Box>

                    <MuiModal
                        top="50%"
                        left="50%"
                        width={'50vh'}
                        open={isEditFormOpen}
                        onClose={() => setIsEditFormOpen(false)}
                    >
                        <TaskForm objToEdit={obj ? obj : null}
                                  project={project}
                                  onSelect={onChange}
                                  onClose={() => setIsEditFormOpen(false)}
                        />
                    </MuiModal>

                    <MuiModal top="50%" left="50%" width={'120vh'} open={isListTableOpen}
                              onClose={() => setIsListTableOpen(false)}
                              disableBackdropClick={true}
                    >
                        <TasksTable
                            project={project}
                            onSelect={handleChange}
                            onClose={() => setIsListTableOpen(false)}
                        />
                    </MuiModal>
                    <MuiModal
                        top="50%"
                        left="50%"
                        width={'80vh'}
                        open={isCurrentInUserWasteCodeCardIsOpen}
                        disableBackdropClick={true}
                        onClose={() => setIsCurrentInUserWasteCodeCardIsOpen(false)}
                    >
                    </MuiModal>
                </>
            )}
        </>
    );
}

export default TaskSelect;